import VerifyTransferInTransferReturn from "../../../../components/@documents/transfer_returns/VerifyTransferInTransferReturn";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TransferReturnVerifyTransferInPage() {

    return (
        <VerifyTransferInTransferReturn 
            routeType={routeTypes.retail}
        />
    )
}